export const sampleTodos = [
    {
        _id: "pd1",
        todoDate: "2026-01-01",
        title: "Read Atomic Habits Chapter 1",
        tags: ["Learning", "Books"],
        status: "Done",
        objective: "Learning",
        description: "Build reading habit",
        completedAt: "2026-01-01",
        isActive: true,
    },

    {
        _id: "pd2",
        todoDate: "2026-01-03",
        title: "30 Minute Workout",
        tags: ["Health", "Fitness"],
        status: "Done",
        objective: "Health",
        description: "Morning exercise",
        completedAt: "2026-01-03",
        isActive: true,
    },

    {
        _id: "pd3",
        todoDate: "2026-01-05",
        title: "Finish Client Proposal",
        tags: ["Career", "Client"],
        status: "Done",
        objective: "Career",
        description: "Submit proposal",
        completedAt: "2026-01-05",
        isActive: true,
    },

    {
        _id: "pd4",
        todoDate: "2026-01-10",
        title: "Deep Work Session",
        tags: ["Focus"],
        status: "Done",
        objective: "Focus",
        description: "90 minute concentration block",
        completedAt: "2026-01-10",
        isActive: true,
    },

    {
        _id: "pd5",
        todoDate: "2026-01-14",
        title: "Build Landing Page",
        tags: ["Build", "Startup"],
        status: "Done",
        objective: "Build",
        description: "Launch MVP",
        completedAt: "2026-01-14",
        isActive: true,
    },

    {
        _id: "pd6",
        todoDate: "2026-01-20",
        title: "Weekly Review",
        tags: ["Growth"],
        status: "Done",
        objective: "Growth",
        description: "Review progress",
        completedAt: "2026-01-20",
        isActive: true,
    },

    {
        _id: "pd7",
        todoDate: "2026-01-24",
        title: "Morning Routine",
        tags: ["Discipline"],
        status: "Done",
        objective: "Discipline",
        description: "Wake up at 6am",
        completedAt: "2026-01-24",
        isActive: true,
    },

    {
        _id: "pd8",
        todoDate: "2026-02-02",
        title: "Launch Marketing Campaign",
        tags: ["Career", "Marketing"],
        status: "Done",
        objective: "Career",
        description: "Campaign execution",
        completedAt: "2026-02-02",
        isActive: true,
    },

    {
        _id: "pd9",
        todoDate: "2026-02-12",
        title: "Meditation Practice",
        tags: ["Focus", "Mindfulness"],
        status: "Done",
        objective: "Focus",
        description: "15 mins meditation",
        completedAt: "2026-02-12",
        isActive: true,
    },

    {
        _id: "pd10",
        todoDate: "2026-02-20",
        title: "Publish Blog Article",
        tags: ["Build", "Writing"],
        status: "Done",
        objective: "Build",
        description: "Content publishing",
        completedAt: "2026-02-20",
        isActive: true,
    },

    {
        _id: "pd11",
        todoDate: "2026-03-01",
        title: "Create Monthly Plan",
        tags: ["Productivity"],
        status: "Planned",
        objective: "Productivity",
        description: "Planning session",
        isActive: true,
    },

    {
        _id: "pd12",
        todoDate: "2026-03-05",
        title: "Gym Session",
        tags: ["Health"],
        status: "Cancelled",
        objective: "Health",
        description: "Skipped due to travel",
        isActive: false,
    },
];

// export const sampleRoaches = [
//     {
//         _id: "roach1",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-01",
//         dayNumber: 1,
//         setId: "1",
//         levers: "9,9,5,5,9,5,9",
//         avgScore: 7.3,
//         type: "⚡ Apex Chaos Roach",
//         isActive: true,
//     },
//     {
//         _id: "roach2",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-02",
//         dayNumber: 2,
//         setId: "1",
//         levers: "5,5,5,5,9,5,9",
//         avgScore: 6.1,
//         type: "🔥 Hardened Survivalist",
//         isActive: true,
//     },
//     {
//         _id: "roach3",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-03",
//         dayNumber: 3,
//         setId: "1",
//         levers: "9,5,9,1,9,5,9",
//         avgScore: 6.7,
//         type: "🔥 Hardened Survivalist",
//         isActive: true,
//     },
//     {
//         _id: "roach4",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-04",
//         dayNumber: 4,
//         setId: "1",
//         levers: "1,1,5,1,5,1,5",
//         avgScore: 2.7,
//         type: "🧊 Low Energy Roach",
//         isActive: true,
//     },
//     {
//         _id: "roach5",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-05",
//         dayNumber: 5,
//         setId: "1",
//         levers: "5,9,9,5,9,1,9",
//         avgScore: 6.7,
//         type: "🔥 Hardened Survivalist",
//         isActive: true,
//     },
//     {
//         _id: "roach6",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-06",
//         dayNumber: 6,
//         setId: "1",
//         levers: "9,9,9,5,9,1,9",
//         avgScore: 7.3,
//         type: "⚡ Apex Chaos Roach",
//         isActive: true,
//     },
//     {
//         _id: "roach7",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-07",
//         dayNumber: 7,
//         setId: "1",
//         levers: "5,5,9,1,9,1,9",
//         avgScore: 5.6,
//         type: "🪳 Balanced Survivor",
//         isActive: true,
//     },
//     {
//         _id: "roach8",
//         subscriptionCycle: [1],
//         subscriptionId: "sample-sub-1",
//         user: "sample-user",
//         userCode: "T5W001",
//         roachDate: "2026-01-08",
//         dayNumber: 8,
//         setId: "1",
//         levers: "9,5,9,5,9,1,9",
//         avgScore: 6.7,
//         type: "🔥 Hardened Survivalist",
//         isActive: true,
//     },
// ];